import { WalletButton } from 'components'
import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks/analytics-tracker'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import Path from 'router'
import { HeaderWrapper, LayoutWrapper } from '../../../styling/common'
import ThemeToggle from './menus/social-media'
import DesktopNavigation from './navigation/desktop'
import {
  AccountCenterWrapper,
  Logo,
  LogoSection,
  MenuWrapper,
  NavigationLogoText,
} from './styling/desktop'
import { PortfolioReturns } from './navigation/storage/interface'

type Props = {
  portfolioReturns: PortfolioReturns
  clickControlReference: React.RefObject<HTMLDivElement>
}
export const DesktopHeader: React.FC<Props> = ({ portfolioReturns, clickControlReference }) => {
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.NavigationBar)
  const navigate = useNavigate()
  const handleNavigate = () => {
    navigationEvent(`${Path.MAIN}`)
    navigate(`${Path.MAIN}`)
  }

  return (
    <>
      <LayoutWrapper>
        <HeaderWrapper>
          <MenuWrapper>
            <LogoSection onClick={handleNavigate}>
              <Logo fileName={'whale'} additionalState={'header'} alt={'Phuture Logo'} />
              <NavigationLogoText>Phuture</NavigationLogoText>
            </LogoSection>
            <DesktopNavigation portfolioReturns={portfolioReturns} />
          </MenuWrapper>
          <AccountCenterWrapper>
            <ThemeToggle />
            <div ref={clickControlReference}>
              <WalletButton buttonType="wallet" />
            </div>
          </AccountCenterWrapper>
        </HeaderWrapper>
      </LayoutWrapper>
    </>
  )
}
